import { ElementHelpers } from'../helpers/element-helpers';
import { CreateCalendar } from '../helpers/create-calendar';
import { DateTimeHelpers } from '../helpers/date-time';

export class AddToCalendar {

	static getSelector() {
		return '[data-add-to-calendar]';
	}

	constructor(elem) {

		// Store our element references
		this.elem = elem;
		this.button = this.elem.querySelector('.add-to-calendar__button');
		this.links = this.elem.querySelectorAll('.add-to-calendar__list li a');

		this.eventWrapper = document.querySelector('.event-content');

		// Gather event info from our element
		this.title = this.elem.getAttribute('data-title');
		this.description = this.elem.getAttribute('data-description');
		this.location = this.elem.getAttribute('data-location');
		this.startDate = this.elem.getAttribute('data-eventStart');
		this.endDate = this.elem.getAttribute('data-eventEnd');

		this.addEventHandlers();
		this.handleLinks();
	}

	addEventHandlers() {
		this.eventWrapper.addEventListener('click', (event) => {
			if (event.target === this.button) {
				event.preventDefault();
				this.elem.classList.toggle('active');
			} else {
				if (this.elem.classList.contains('active')) {
					this.elem.classList.remove('active');
				}
			}
		});

		ElementHelpers.addEventListeners(this.links, 'click', (event) => {

			// Download our ICS if our target has a calendar action
			if (event && event.target.calendarAction) {
				event.preventDefault();
				event.target.calendarAction.download();
			}
		});
	}

	handleLinks() {
		for (let i = 0; i < this.links.length; i++) {
			this.generateUrls(this.links[i]);
		}
	}

	getRandomKey() {
		let n = Math.floor(Math.random() * 999999999999).toString();
		return new Date().getTime().toString() + '_' + n;
	}

	generateUrls(item) {
		const linkType = item.getAttribute('data-calendarLink');
		let calendarAction = '';

		switch (linkType) {
			case 'google':
				calendarAction = 'https://calendar.google.com/calendar/render';
				calendarAction += '?action=TEMPLATE';
				calendarAction += `&dates=${DateTimeHelpers.formatTime(this.startDate)}`;
				calendarAction += `/${DateTimeHelpers.formatTime(this.endDate)}`;
				calendarAction += `&location=${encodeURIComponent(this.location)}`;
				calendarAction += `&text=${encodeURIComponent(this.title)}`;
				calendarAction += `&details=${encodeURIComponent(this.description)}`;
				item.href = calendarAction;
				break;

			case 'yahoo':
				// yahoo doesn't utilize endTime so we need to calulate duration
				calendarAction = 'https://calendar.yahoo.com/?v=60&view=d&type=20';
				calendarAction += '&title=' + encodeURIComponent(this.title);
				calendarAction += `&st=${DateTimeHelpers.formatTime(this.startDate)}`;
				calendarAction += `&dur=${DateTimeHelpers.calculateDuration(this.startDate, this.endDate)}`;
				calendarAction += `&desc=${encodeURIComponent(this.description)}`;
				calendarAction += `&in_loc=${encodeURIComponent(this.location)}`;
				item.href = calendarAction;
				break;

			case 'outlook':
				calendarAction = 'https://outlook.live.com/owa/?rru=addevent';
				calendarAction += `&startdt=${DateTimeHelpers.formatTime(this.startDate)}`;
				calendarAction += `&enddt=${DateTimeHelpers.formatTime(this.endDate)}`;
				calendarAction += `&subject=${encodeURIComponent(this.title)}`;
				calendarAction += `&location=${encodeURIComponent(this.location)}`;
				calendarAction += `&body=${encodeURIComponent(this.description)}`;
				calendarAction += '&allday=false';
				calendarAction += `&uid=${this.getRandomKey()}`;
				calendarAction += '&path=/calendar/view/Month';
				item.href = calendarAction;
				break;

			default:

				// Default case where we generate an ICS file with the provided event data
				this.location = this.location.replace(/,/g, ' -');
				calendarAction = new CreateCalendar();
				calendarAction.addEvent(
					this.title,
					this.description,
					this.location,
					this.startDate,
					this.endDate
				);
				item.calendarAction = calendarAction;
		}
	}
}

